import type { StatusLedMapping, StatusLedWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  ColourField,
  ListEditor,
  Row,
  ScalarField,
  Section,
  TextField,
  formatScalar,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Zustands-Leuchte. Die Zuordnung ist der ganze Inhalt: welcher Wert welche
 *  Farbe bekommt, und wie er auf dem Schirm heisst. */
export function StatusLedEditor(
  { widget, plantId, missing, onChange }: WidgetEditorProps<StatusLedWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Zustands-Datenpunkt"
          value={widget.statePoint}
          plantId={plantId}
          onChange={(next) => patch({ statePoint: next })}
        />
      </Section>
      <Section title="Anzeige">
        <CheckboxField
          label="Beschriftung anzeigen"
          checked={widget.showLabel !== false}
          onChange={(next) => patch({ showLabel: next })}
        />
      </Section>
      <Section title="Zuordnung">
        <ListEditor<StatusLedMapping>
          label="Wert zu Farbe"
          required
          missing={missing.has('mapping')}
          items={widget.mapping}
          addLabel="Zuordnung"
          emptyHint="Ohne Zuordnung bleibt die Leuchte grau, egal was der Regler meldet."
          hint="Ein Wert, der in keiner Zeile steht, bleibt neutral. Das ist Absicht: eine unbekannte Zahl soll nicht wie ein bekannter Zustand aussehen."
          create={() => ({ value: undefined, colour: '#8a929e' })}
          itemTitle={(m, i) => m.label || formatScalar(m.value) || `Zeile ${i + 1}`}
          onChange={(next) => patch({ mapping: next })}
          renderItem={(entry, patchEntry) => (
            <>
              <Row>
                <ScalarField
                  label="Wert"
                  value={entry.value}
                  required
                  onChange={(next) => patchEntry({ value: next })}
                />
                <ColourField
                  label="Farbe"
                  value={entry.colour}
                  onChange={(next) => patchEntry({ colour: next ?? '' })}
                />
              </Row>
              <TextField
                label="Beschriftung"
                value={entry.label}
                placeholder="Läuft"
                onChange={(next) => patchEntry({ label: next })}
              />
            </>
          )}
        />
      </Section>
    </>
  );
}
